import { Box } from "@similarweb/ui-components/foundations";

import { useElementSize } from "app/pages/market-research/hooks/useElementSize";

import { Loader } from "./components/Loader";
import { useKeywordListComposerContext } from "./KeywordListComposerContext";
import { KeywordListComposerCreatorBodyHeader } from "./KeywordListComposerCreatorBodyHeader";
import { KeywordListComposerKeywordList } from "./KeywordListComposerKeywordList";

export const KeywordListComposerCreatorSuggestions = () => {
    const [wrapperRef, wrapperSize] = useElementSize();
    const { suggestionsStatus, query, keywords, selectKeywords, removeKeywords } = useKeywordListComposerContext();

    return (
        <>
            <KeywordListComposerCreatorBodyHeader />

            <Box
                ref={wrapperRef}
                flexGrow="1"
                overflowY="auto"
            >
                {suggestionsStatus === "pending" ? (
                    <Loader />
                ) : (
                    <KeywordListComposerKeywordList
                        width={wrapperSize.width}
                        height={wrapperSize.height}
                        query={query}
                        keywords={keywords}
                        onSelectKeyword={selectKeywords}
                        onDeleteKeyword={removeKeywords}
                    />
                )}
            </Box>
        </>
    );
};
